import { render, staticRenderFns } from "./ApeironSharedWithUser.vue?vue&type=template&id=498daa68"
import script from "./ApeironSharedWithUser.vue?vue&type=script&lang=js"
export * from "./ApeironSharedWithUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports